"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicBookingPage = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var react_router_dom_1 = require("react-router-dom");
var book_1 = require("./pages/book");
var details_1 = require("./pages/details");
var history_1 = require("./pages/history");
var sign_in_required_1 = require("../../components/sign_in_required");
var react_redux_1 = require("react-redux");
var ClinicBookingPage = function () {
    var params = (0, react_router_dom_1.useParams)();
    var _a = (0, react_1.useState)(true), isLoading = _a[0], setIsLoading = _a[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-8" }, user._id ? (react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { index: true, element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/clinic/booking/history" }) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/new", element: react_1.default.createElement(book_1.BookClinicPage, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/details/:bookingID", element: react_1.default.createElement(details_1.ClinicBookingDetailsPage, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/history", element: react_1.default.createElement(history_1.ClinicBookingHistoryPage, null) }))) : (react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null)))));
};
exports.ClinicBookingPage = ClinicBookingPage;
